import { inject, Injectable, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private translate = inject(TranslateService);

  private _lang = signal<'en' | 'fr'>(
    (localStorage.getItem('tsin-lang') as 'en' | 'fr') || 'en'
  );

  /** Read-only signal for the current language. */
  current = this._lang.asReadonly();

  constructor() {
    // Apply the persisted (or default) language immediately so translation
    // files are loaded even on pages that don't call translate.use() themselves.
    this.translate.use(this._lang());
  }

  /**
   * Persist and apply a language change.
   * Calling this will update the signal, localStorage, and ngx-translate simultaneously.
   */
  set(lang: 'en' | 'fr'): void {
    this._lang.set(lang);
    localStorage.setItem('tsin-lang', lang);
    this.translate.use(lang);
  }
}
